import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import CustomDialog from '../CustomDialog';
import { Button, Divider, Typography } from '@mui/material';
import { useAppDispatch } from '../../hooks/useAppDispatch';
import { logout, loginWithGoogle } from '../../store/slices/auth';
import { unsetPathBeforeLoginRequest } from '../../store/slices/sessionStatus';
import { useAppSelector } from '../../hooks/useAppSelector';
import Box from '@mui/material/Box';
import { GoogleLogin } from '@react-oauth/google';

const LoginRequired = () => {
    const history = useHistory();
    const dispatch = useAppDispatch();
    const auth = useAppSelector((state) => state.auth);
    const sessionStatus = useAppSelector((state) => state.sessionStatus);
    const { userLoginSuccess, userLogingIn } = auth;
    const { pathBeforeLoginRequest } = sessionStatus;

    useEffect(() => {
        if (!userLogingIn && userLoginSuccess) {
            const terms = auth.tokenData?.data?.terms;
            if (terms === false) {
                history.push('/accept-terms');
                return;
            }
            if (pathBeforeLoginRequest) {
                history.push(pathBeforeLoginRequest);
                dispatch(unsetPathBeforeLoginRequest());
            } else {
                history.push('/');
            }
        }
    }, [userLogingIn, userLoginSuccess]);

    return (
        <CustomDialog
            title={'Join the community'}
            alternative={'Share and discover FPV spots with pilots around you.'}
            closeCopy={'Maybe later'}
            sx={{
                '& .MuiDialog-container': {
                    width: '500px'
                }
            }}
        >
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                <GoogleLogin
                    onSuccess={(credentialResponse) => {
                        if (credentialResponse.credential) {
                            void dispatch(loginWithGoogle(credentialResponse.credential));
                        }
                    }}
                    onError={() => console.error('Google sign-in failed')}
                />
                <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', gap: 1 }}>
                    <Divider sx={{ flex: 1 }} />
                    <Typography variant='caption' color='text.secondary'>or</Typography>
                    <Divider sx={{ flex: 1 }} />
                </Box>
                <Box sx={{ display: 'flex', gap: 2 }}>
                    <Button
                        variant='contained'
                        onClick={() => {
                            dispatch(logout());
                            history.push('/sign-up');
                        }}
                    >
                        Create account
                    </Button>
                    <Button
                        color={'primary'}
                        variant='outlined'
                        onClick={() => {
                            dispatch(logout());
                            history.push('/sign-in');
                        }}
                    >
                        Sign in
                    </Button>
                </Box>
            </Box>
        </CustomDialog>
    );
};

export default LoginRequired;
